import { Suspense } from "react";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import MarketingAgencyPage from "./components/Pages/MarketingAgencyPage";
import ServicePage from "./components/Pages/ServicePage";
import AboutPage from "./components/Pages/AboutPage";
import BlogPage from "./components/Pages/BlogPage";
import BlogListPage from "./components/Pages/BlogListPage";
import BlogDetailsPage from "./components/Pages/BlogDetailsPage";
import ContactPage from "./components/Pages/ContactPage";
import ServiceDetailsPage from "./components/Pages/ServiceDetailsPage";
import ErrorPage from "./components/Pages/ErrorPage";

// import PortfolioPage from "./components/Pages/PortfolioPage";
// import PortfolioDetailsPage from "./components/Pages/PortfolioDetailsPage";
// import TeamPage from "./components/Pages/TeamPage";
// import TeamDetailsPage from "./components/Pages/TeamDetailsPage";
// import Home from "./components/Pages/Home";
// import StudioAgencyPage from "./components/Pages/StudioAgencyPage";
// import DigitalAgencyPage from "./components/Pages/DigitalAgencyPage";
// import CaseStudyDetailsPage from "./components/Pages/CaseStudyDetailsPage";
// import Layout2 from "./components/Layout/Layout2";
// import TechStartupPage from "./components/Pages/TechStartupPage";
// import Shop from "./components/Pages/Shop";
// import ProductDetails from "./components/Pages/Shop/ProductDetails";
// import Cart from "./components/Pages/Shop/Cart";
// import Checkout from "./components/Pages/Shop/Checkout";
// import Success from "./components/Pages/Shop/Success";
// import Wishlist from "./components/Pages/Shop/Wishlist";
// import Layout3 from "./components/Layout/Layout3";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Layout darkMode />}>
          <Route path="/" element={<MarketingAgencyPage darkMode />} />
          <Route path="about" element={<AboutPage darkMode />} />
          <Route path="service" element={<ServicePage />} />
          <Route
            path="service/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-list" element={<BlogListPage />} />
          <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
